module.exports = __webpack_public_path__ + "61adc1fa059d8e105c0660f9996d0f46.jpg";